/* WORDFILTER — the one place the app decides what a typed filter MATCHES, and what the match
 * looks like once it is painted.
 *
 * Lifted out of main.js's WordListsPanel (2026-08-11) when a second surface needed the same
 * behaviour: the Session history popup's "words mastered" list. Two copies of these rules would
 * have drifted the moment either language grew a substitution — and the rules are exactly the part
 * a user notices, because they are the difference between typing `ueber` and finding *über* or
 * finding nothing.
 *
 * Rules only. The widget around them (debounce, the clear ×, what ENTER does) stays with whoever
 * owns the surface: the word-list panel's box restarts a server-backed list and arms an
 * open-the-word action, the history popup's box filters an array already in hand. Same match, two
 * different jobs around it.
 */
window.WORDFILTER = (function () {
	"use strict";

	// The learned language's ASCII stand-ins, as MATCH alternatives — typed `ue` finds both `ue`
	// and `ü`, so a user without a German keyboard reaches every word. The same table the typing
	// fields advertise (type_subst.js); ß→ss is deliberately one-way here as it is there.
	var FILTER_SUBST  = { "ae": "(?:ae|[äÄ])", "oe": "(?:oe|[öÖ])",
	                      "ue": "(?:ue|[üÜ])", "ss": "(?:ss|ß)" };
	var FILTER_UMLAUT = { "ä": "[äÄ]", "ö": "[öÖ]", "ü": "[üÜ]" };

	/**
	 * The regex a typed filter means in `langCode`'s alphabet, or null for an empty filter.
	 * Case-insensitive: German case twins (sie / Sie) are different WORDS, but nobody filtering a
	 * list wants to be told they typed the wrong case.
	 */
	function regex(filter, langCode) {
		var typed = $.trim(filter || "");
		if (!typed) { return null; }
		var german = (langCode || "") === "DE";
		var lower = typed.toLowerCase();
		var out = "";
		for (var i = 0; i < lower.length; ) {
			var pair = german ? FILTER_SUBST[lower.substring(i, i + 2)] : null;
			if (pair) { out += pair; i += 2; continue; }
			var c = lower.charAt(i++);
			var cls = german ? FILTER_UMLAUT[c] : null;
			// Escape ASCII punctuation only; a letter above 127 is never a metacharacter.
			var literal = (/[0-9A-Za-z]/.test(c) || c.charCodeAt(0) > 127) ? c : "\\" + c;
			out += cls ? cls : literal;
		}
		try { return new RegExp(out, "i"); } catch (e) { return null; }
	}

	/**
	 * Repaint a word with its matched run in blue. Reuses the dictionary's own match classes
	 * (revMatchClass / revMatchFullClass, views/dictionary.css) rather than minting a second blue —
	 * "this is the part you typed" has to look the same wherever the app says it.
	 *
	 * The FULL-match class is not decoration: surfaces read it back off the DOM to decide what
	 * ENTER should open, so the rule the user sees (the word that went entirely blue) is the rule
	 * the code follows.
	 */
	function paint(span, word, filter, langCode) {
		var re = regex(filter, langCode);
		var hit = re ? re.exec(String(word || "")) : null;
		if (!hit) { span.text(word); return; }
		var at = hit.index;
		var end = at + hit[0].length;
		span.empty()
			.append(document.createTextNode(word.substring(0, at)))
			.append($("<span class='revMatchClass'></span>")
				.toggleClass("revMatchFullClass", at === 0 && end === word.length)
				.text(word.substring(at, end)))
			.append(document.createTextNode(word.substring(end)));
	}

	return {
		regex: regex,
		paint: paint
	};
})();
